// Dates from the API are date-only business dates serialized as
// "yyyy-MM-ddT00:00:00". NEVER round-trip them through a JS Date —
// timezone conversion shifted them by a day (item 13). Slice the string.

export const SqlDateTimeToDateField = (sqlDate: string): string => (sqlDate ? sqlDate.split('T')[0] : '');

// For display (e.g. M/D/YYYY in grids) — still string math, no Date object.
export const SqlDateTimeToDisplay = (sqlDate: string): string => {
  const datePart = SqlDateTimeToDateField(sqlDate);
  if (!datePart) return '';
  const [year, month, day] = datePart.split('-');
  return `${Number(month)}/${Number(day)}/${year}`;
};
